import { Platform, StatusBar } from 'react-native'

// export const JWT =
// 	'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpc3MiOiJ1c2VyIiwic3ViIjoiMTAwMDAwMDAxIiwiaWF0IjoxNzEyODAyMjEyLCJleHAiOjE3MTI4MDMxMTIsImF1ZCI6WyIzMSJdLCJsZXZlbCI6MCwiYXJlYSI6ODg2LCJhY2NvdW50IjoiYWxpY2UifQ.G1X27cJ3pUZG0I92Ul2mjvG-wmO6nB-ALN2fxp7eeiXt8bwBqCYlWTvjeoW3kZNF6_RqgpG1diej52H6swBls4atSoo_vQZ3VovBttNiMzI7gtZlFSOJpzlrdigByaxZmvjnSbryzvGD7R7Wlkm9QCOM6uNWFDCGSez-TEBejGh83jGnBXrw5UA8yYerEgGo_g7rl028o_lN8y-Ao847UyR9dpJ9vck9w_XS3qYsfuTDanVx5EQ77yUdrIaA8_I_LXoDqkZA4HkwvK4CtG1souIsis0ZmhqUyuJoxMtufF48Cf8C4peaX9mY0rCyfXjDyLXvhseSFn5UV3PscDnQ7w';

import { Logo } from '@/components/icon'
import { marketPresentation } from '@/config/marketPresentation'

export const PAGES = ['home', 'swap', 'transaction', 'order', 'profile'] as const

export const STATUS_BAR_HEIGHT = (Platform.OS === 'android' ? StatusBar.currentHeight : 48) || 48

export const END_POINT = 'http://localhost:3030/mobile/secure/graphql'

export enum UserFlags {
  EMPTY = 0,
  ACTIVE = 1 << 0,
  PHONE_VERIFIED = 1 << 1,
  EMAIL_VERIFIED = 1 << 2,
  KYC_1_SUBMITTED = 1 << 3,
  KYC_1_VERIFIED = 1 << 4,
  KYC_2_SUBMITTED = 1 << 5,
  KYC_2_VERIFIED = 1 << 6,
  KYC_3_SUBMITTED = 1 << 7,
  KYC_3_VERIFIED = 1 << 8,
  PROFILE_IMG = 1 << 9,
  COIN_MERCHANT = 1 << 10,
  COIN_AGENT = 1 << 11,
  COIN_MERCHANT_BLOCK_DISPLAY = 1 << 12,
  DEFAULT_PASSWORD = 1 << 13,
  KYC_1_REJECTED = 1 << 14
}

export const CURRENCY_KIND = Object.freeze({
  YBB: {
    name: marketPresentation.platformToken.displayName,
    unit: marketPresentation.platformToken.code,
    icon: Logo
  }
})

export enum PaymentKind {
  bank,
  alipay,
  wechat,
  ermb,
  qq
}

export const PAYMENT_METHODS = ['bank', 'alipay', 'wechat', 'ermb', 'qq'] as const

export enum BuyOrderStatus {
  uninitialized,

  // happy path
  unpaired, // waiting for sell order paired
  paired, // auto pair sell order
  paymentMade, // buyer upload payment proof
  completed, // seller confirm payment proof
  canceling, // request cancel sell order // 5
  canceled, // canceled with approval of admin

  // unhappy path
  forceCanceled, // forcefully canceled by admins or buyer
  complainted, // buyer or seller complaint
  appealing
}

export enum SellOrderStatus {
  uninitialized,

  // happy path
  unpaired, // waiting for buy order paired
  paired, // auto pair buy order
  paymentMade, // buyer upload payment proof
  completed, // seller confirm payment proof

  // unhappy path
  requestCancel, // request cancel sell order //5
  canceling, // request cancel sell order
  canceled, // canceled with approval of admin
  forceCanceled, // forcefully canceled by admins or seller
  complainted,
  appealing
}

export enum NotificationKind {
  SELL_ORDER_PAIRED,
  BUY_ORDER_PAIRED,
  BUY_ORDER_UPLOAD_PAYMENT_PROOF,
  SELL_ORDER_COMFIRMED_PAYMENT_PROOF,
  BUY_ORDER_CANCELED,
  BUY_ORDER_REQUEST_APPEAL_FROM_SELLER, // 5
  BUY_ORDER_REQUEST_APPEAL_FROM_BUYER,
  SELL_ORDER_CHANGED_AMOUNT,
  BUY_ORDER_AGREED_CHANGE_AMOUNT,
  BUY_ORDER_DISAGREED_CHANGE_AMOUNT,
  SELL_ORDER_REQUEST_PAIR_CANCELED, // 10
  ADMIN_APPROVED_PAIR_CANCELED,
  ADMIN_REJECTED_PAIR_CANCELED,
  ADMIN_FORCE_CANCELED_PAIR,
  ADMIN_FORCE_CANCELED_SELL_ORDER,
  ADMIN_FORCE_CANCELED_BUY_ORDER, // 15
  ADMIN_FORCE_CONFIRMED,
  ADMIN_FORCE_CHANGED_AMOUNT,
  ADMIN_BUY_ORDER_CANCELED,
  BUYER_BUY_ORDER_FORCE_CANCELED,

  // wallet notification
  USER_RECEIVED_PAYMENT_GATEWAY,
  USER_TRANSFERRED_PAYMENT_GATE_WAY,
  USER_RECEIVED_PAYOUT,
  USER_TRANSFERRED_PAYOUT, //20
  USER_RECEIVED_TRANSFER,
  USER_TRANSFERRED_TRANSFER,
  USER_RECEIVED_EXCHANGE,
  USER_TRANSFERRED_EXCHANGE,
  ADMIN_REJECT_KYC,
  ADMIN_APPROVE_KYC,

  BONUS_ACTIVITY_CREATED
}

export enum AppealKind {
  UploadPaymentProofFailed,
  BankInfoError,
  WechatInfoError,
  AlipayInfoError,
  QQInfoError,
  SellerDidNotConfirm,
  CannotConfirmBuyerPaymentProof,
  SellerNotReceivedPayment,
  Other
}

export type AppealKindOptions = AppealKind | 'AmountMismatch'

export enum BonusActivityStatus {
  default,
  Uninitialized,
  Active,
  Inactive,
  Ended
}

export type AssetOption = 'all' | 'deposit' | 'payment' | 'swap' | 'buyCoin' | 'sellCoin' | 'return' | 'others'
export type AssetOptions = AssetOption[]

export const ASSET_OPTIONS: AssetOptions = [
  'all',
  'deposit',
  'swap',
  'payment',
  'buyCoin',
  'sellCoin',
  'return',
  'others'
]

export const VALID_IMAGE_TYPE = ['image/jpeg', 'image/png']
export const MAX_IMAGE_SIZE = 5 * 1024 * 1024
export const VALID_VIDEO_TYPE = ['video/mp4', 'video/x-msvideo', 'video/quicktime']
export const MAX_VIDEO_SIZE = 200 * 1024 * 1024
export const PAGE_SIZE = 20
export const MAX_DEAL_AMOUNT = Math.pow(2, 53) - 1
